import React from "react";

import { Box, Checkbox, Group, Table } from "@mantine/core";

import { IconCornerDownRight, IconFirstAidKit } from "@tabler/icons-react";

import { TextWrapper } from "@/components/TextWrapper";

import { ENCOUNTER_TABLE_COLUMNS } from "../constants/tables";
import { EncounterTableProps } from "../interfaces/encounter-table";

import { EmptyStateTable } from "./EmptyStateTable";

export function EncounterTable({ items, onItemChange, onFlowsheetChange }: EncounterTableProps) {
  if (items.length === 0) {
    return (
      <EmptyStateTable
        columns={ENCOUNTER_TABLE_COLUMNS}
        message="There are currently no encounters for this client."
        icon={<IconFirstAidKit size={18} color="var(--mantine-color-gray-6)" />}
      />
    );
  }

  return (
    <Box
      style={{
        overflow: "hidden",
        borderRadius: "var(--mantine-radius-md)",
        border: "1px solid var(--mantine-color-cream-4)",
      }}
    >
      <Table withRowBorders verticalSpacing="md" borderColor="cream.4" horizontalSpacing="md">
        <Table.Thead bg="cream.3">
          <Table.Tr>
            {ENCOUNTER_TABLE_COLUMNS.map((column) => (
              <Table.Th key={column}>
                <TextWrapper c="dark.9" variant="bold">
                  {column}
                </TextWrapper>
              </Table.Th>
            ))}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {items.map(
            (
              {
                key,
                checked,
                weeks,
                encounterServiceType,
                encounterDate,
                episodeOfCare,
                encounterClass,
                encounterType,
                encounterHasFlowsheet,
                flowsheetChecked = true,
              },
              index,
            ) => (
              <React.Fragment key={key}>
                <Table.Tr>
                  <Table.Td>
                    <Checkbox
                      checked={checked}
                      label={encounterDate}
                      onChange={(event) => onItemChange(index, event.currentTarget.checked)}
                    />
                  </Table.Td>
                  <Table.Td>
                    <TextWrapper>{encounterServiceType}</TextWrapper>
                  </Table.Td>
                  <Table.Td>
                    <TextWrapper>{encounterType}</TextWrapper>
                  </Table.Td>
                  <Table.Td>
                    <TextWrapper>{encounterClass}</TextWrapper>
                  </Table.Td>
                  <Table.Td>
                    <TextWrapper>{weeks ?? "-"}</TextWrapper>
                  </Table.Td>
                  <Table.Td>
                    <TextWrapper>{episodeOfCare ?? "-"}</TextWrapper>
                  </Table.Td>
                </Table.Tr>
                {encounterHasFlowsheet && checked && (
                  <Table.Tr>
                    <Table.Td colSpan={6}>
                      <Group gap="xs" wrap="nowrap">
                        <IconCornerDownRight size={20} color="var(--mantine-color-gray-6)" />
                        <Checkbox
                          color="burgundy.9"
                          checked={flowsheetChecked}
                          label={`include ${encounterServiceType?.toLowerCase() ?? ""} flowsheet?`}
                          onChange={(event) =>
                            onFlowsheetChange?.(index, event.currentTarget.checked)
                          }
                        />
                      </Group>
                    </Table.Td>
                  </Table.Tr>
                )}
              </React.Fragment>
            ),
          )}
        </Table.Tbody>
      </Table>
    </Box>
  );
}
